import { IProject } from "@/interfaces/project.interface"
import { STORAGE_KEY } from "./projeto-constants"

export function readPersistedId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    // SSR ou storage bloqueado
    return null
  }
}

export function persistId(id: string | null): void {
  try {
    if (id === null) {
      localStorage.removeItem(STORAGE_KEY)
    } else {
      localStorage.setItem(STORAGE_KEY, id)
    }
  } catch {
    // Ignora falhas de storage (modo privado com storage cheio, etc.)
  }
}

export function resolveInitialProject(projects: IProject[], persistedId: string | null): IProject | null {
  if (!projects.length) return null

  if (persistedId) {
    const match = projects.find((p) => String(p.id) === persistedId)
    if (match) return match
  }

  return projects[0]
}